import {
  CapacityDashboard_Request,
  CapacityResponseSchema,
} from '@dispatch/shared/types';
import { dispatchClient } from '../clients';
import { z } from 'zod';

const APIM_SERVICE_CACACITY_DASHBOARD_URL = '/resourceCapacity';

type CapacityDashboardApiResponseSchema = z.infer<
  typeof CapacityResponseSchema
>;

export async function getCapacityDashboard(
  filters: CapacityDashboard_Request
): Promise<CapacityDashboardApiResponseSchema> {
  try {
    const response =
      await dispatchClient.post<CapacityDashboardApiResponseSchema>(
        APIM_SERVICE_CACACITY_DASHBOARD_URL,
        filters
      );

    return response.data;
  } catch (e) {
    throw new Error('Error fetching capacity dashboard data');
  }
}
